import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'large' ? 'aspect-[16/9]' : 'aspect-[2/3]'
      }`}>
        <img
          src={movie.poster}
          alt={`${movie.title} - ${movie.titleEn}`}
          title={`${movie.title} 高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <p className="text-background-50 text-xs leading-relaxed line-clamp-3">
              {movie.description}
            </p>
          </div>
        </div>

        {movie.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[10px] font-semibold whitespace-nowrap">
            NEW
          </span>
        )}
        {movie.isHot && !movie.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[10px] font-semibold whitespace-nowrap">
            热播
          </span>
        )}

        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-accent-500 text-[10px] font-semibold whitespace-nowrap">
          {movie.rating}
        </div>
      </div>

      <div className="mt-2 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{movie.year}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{movie.categoryLabel}</span>
          {movie.rating && (
            <>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs text-accent-600 font-medium">{movie.rating}分</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}